export default "__VITE_ASSET__79873abf__"